// Third party
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';

// Hooks
import { useAppSelector } from '../../useAppStore';
import { ProfileController } from '../../../services';
import { useGetProfileInfo } from './useGetProfileInfo';
import { useGetShooterProfileInfo } from './useGetShooterProfileInfo';

// Components
import { useError } from '../../useError';
import { getAuthInfo } from '../../../store';
import { TAxiosError } from '../../../types/responses';
import { TProfileUpdateReq } from '../../../types/requests';

export function useUpdateProfileInfoAPI() {
  const { handleReqError } = useError();
  const { enqueueSnackbar } = useSnackbar();
  const authInfo = useAppSelector(getAuthInfo);

  const { refetch: getProfileInfo } = useGetProfileInfo();
  const { refetch: getShooterInfo } = useGetShooterProfileInfo();

  const updateProfileInfoAPI = async (data: TProfileUpdateReq) => {
    return await ProfileController().updateProfileInfo(data);
  };

  return useMutation({
    mutationFn: updateProfileInfoAPI,
    onSuccess: async () => {
      const { user_type } = authInfo;

      if (user_type === 'PERSONAL') {
        await getShooterInfo();
      }

      if (user_type === 'MANAGED') {
        await getProfileInfo();
      }

      enqueueSnackbar('Personal Information Successfully Updated!', {
        variant: 'success',
      });
    },
    onError: async (error: TAxiosError) => {
      if (error.response?.data?.detail.includes('already exists')) {
        enqueueSnackbar('Email already exists', { variant: 'error' });
        return;
      } else {
        await handleReqError(error);
      }
    },
  });
}
